import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

interface IPlanSelectPayload {
    event_category?: string;
    event_action: string;
}

export const hitPlanSelectEvent = (payload: IPlanSelectPayload) => {
    hitGoogleTagManager({
        event: "property_view",
        ...payload
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

interface IPlanSelectPayload {
    event_category?: string;
    event_action: string;
}

export const hitPlanSelectEvent = (payload: IPlanSelectPayload) => {
    hitGoogleTagManager({
        event: "property_view",
        ...payload
    });
};
